export const stateStrategy = {
  registered: 'registered',
  qualifying: 'qualifying',
  qualifying_client_changes_requested: 'qualifying',
  qualifying_quote_client_review: 'qualifying',
  qualifying_review: 'qualifying',
  qualifying_quote: 'qualifying',
  deploying: 'deploying',
  deploying_management_review: 'deploying',
  completed: 'deploying'
} as const

export const translateStateStrategy = {
  registered: 'Registrado',
  qualifying: 'Qualificando',
  deploying: 'Implantação'
}
